class LLNextTierPoints extends HHBaseElement {
  constructor() {
    super()

    this.interval = null
    this.setup = this.setup.bind(this)
    this.checkLoyaltyStatus = this.checkLoyaltyStatus.bind(this)
  }

  get message() {
    return decodeURIComponent(this.getAttribute('message'))
  }

  connectedCallback() {
    this.setup()
  }

  setup() {
    if (typeof window.loyaltylion?.customer?.loyaltyTierMembership?.loyaltyTierId === 'undefined' || typeof window.loyaltylion?.program?.loyaltyTiers === 'undefined') {
      this.interval = setInterval(this.checkLoyaltyStatus, 500)
    }
  }

  checkLoyaltyStatus() {
    if (window.loyaltylion?.customer?.loyaltyTierMembership?.loyaltyTierId && window.loyaltylion?.program?.loyaltyTiers) {
      this.render()
      clearInterval(this.interval)
    }
  }

  hide() {
    this.style.display = 'none'
  }

  render() {
    try {
      const loyaltyTierId =
        window.loyaltylion.customer.loyaltyTierMembership.loyaltyTierId
      const tiers = window.loyaltylion.program?.loyaltyTiers?.filter(tier => tier.hidden === false)
      const matchingTierIndex = tiers?.findIndex(
        (tier) => tier.id === loyaltyTierId
      )

      document.querySelectorAll('.js-current-ll-tier').forEach(tierElem => {
        tierElem.innerHTML = tiers[matchingTierIndex].name
        tierElem.setAttribute('data-tier', tiers[matchingTierIndex].name.toLowerCase())
      })

      const nextTier = tiers[matchingTierIndex + 1]
      if (!nextTier) {
        return this.hide()
      }

      const points = window.loyaltylion.customer.pointsTotal
      const pointsToNextTier = nextTier.bounds.lower - points
      if (pointsToNextTier <= 0) {
        return this.hide()
      }

      this.innerHTML = this.message
        .replace('{points}', pointsToNextTier / 100)
        .replace('{tier}', nextTier.name)
    } catch (error) {
      console.error(error)
    }
  }
}

window.customElements.define('ll-next-tier-points', LLNextTierPoints)
